import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  container: {
    margin: '40px 2% 0 34px',
    width: 'auto',
    height: '650px',
  },
  buttonsContainer: {
    display: 'flex',
    gap: '8px',
  },
}))
